import DOMPurify from "dompurify";
import MarkdownIt from "markdown-it";

const SAFE_URL_PROTOCOLS = new Set(["http:", "https:", "mailto:", "tel:"]);

function isSafeMarkdownUrl(url: string) {
  const normalizedUrl = Array.from(url.trim())
    .filter((char) => {
      const code = char.charCodeAt(0);
      return code > 0x1f && code !== 0x7f && !/\s/.test(char);
    })
    .join("");

  if (
    normalizedUrl.startsWith("#") ||
    normalizedUrl.startsWith("/") ||
    normalizedUrl.startsWith("./") ||
    normalizedUrl.startsWith("../")
  ) {
    return true;
  }

  try {
    const parsedUrl = new URL(normalizedUrl, window.location.origin);
    return SAFE_URL_PROTOCOLS.has(parsedUrl.protocol);
  } catch {
    return false;
  }
}

const markdown = new MarkdownIt({
  html: false,
  linkify: true,
  breaks: true,
  typographer: true,
});
markdown.validateLink = isSafeMarkdownUrl;

const defaultLinkOpen =
  markdown.renderer.rules.link_open ||
  ((tokens, idx, options, _env, self) => self.renderToken(tokens, idx, options));

markdown.renderer.rules.link_open = (tokens, idx, options, env, self) => {
  const href = tokens[idx].attrGet("href") || "";

  if (href.startsWith("http://") || href.startsWith("https://")) {
    tokens[idx].attrSet("target", "_blank");
    tokens[idx].attrSet("rel", "noopener noreferrer");
  }

  return defaultLinkOpen(tokens, idx, options, env, self);
};

export function renderSafeMarkdown(source: string) {
  const unsafeHtml = markdown.render(source);

  return DOMPurify.sanitize(unsafeHtml, {
    ADD_ATTR: ["target"],
    FORBID_ATTR: ["style"],
    FORBID_TAGS: ["style"],
  });
}
